const campaign_card = [
    {
        id: 1,
        campaign_name: "Deals made for you",
        date :"31 Dec 2021 - 31 Dec 2022",
        path : "/discount10",
        promo:"Discount_10",
        description: "Deals made especially for you",
        thumb: "https://img.freepik.com/premium-vector/baby-fashion-sale-instagram-story-design-kids-fashion-social-media-post_420373-173.jpg?w=826"
    },
    {
        id: 2,
        campaign_name: "Cyber Sale",
        date :"31 Dec 2021 - 31 Dec 2022",
        path : "/discount25",
        promo:"Discount_25",
        description: "Cyber Sale",
        thumb: "https://img.freepik.com/free-vector/fashion-poster-with-shirt-bag-denim-shorts-shoes_83728-1897.jpg?w=826&t=st=1659361493~exp=1659362093~hmac=3d6b48712c6b5aa7b6716cb517c9e5549b405df6ca21ea845de68a65b8ef3f16"
    },
    {
        id: 3,
        campaign_name: "The biggest sale",
        date :"31 Dec 2021 - 31 Dec 2022",
        path : "/discount50",
        promo:"Discount_50",
        description: "The biggest sale",
        thumb: "https://img.freepik.com/free-psd/store-sale-flyer-template_23-2148667993.jpg?w=826&t=st=1659361517~exp=1659362117~hmac=3bf48449a85c7da9be02d4231f11ecfc8b3e8e07f3cedd8ea6528705c286c5f3"
    },
]
export default campaign_card;